// @ts-strict-ignore
import angular from 'angular';

const dependencies = [];

/**
 * @module The SystemWarning module
 */
angular.module('Sq.SystemWarning', dependencies);
